import { NotificationLevel, NotificationsService } from './../../../../services/api/notifications/notifications.service';
import { PartyCharacteristic } from '../../../../models/party-manager/party-characteristic';
import { PartyService } from './../../../../services/api/party/party.service';
import { PartySpecification } from '../../../../models/party-manager/partySpecifications';
import { Party } from 'src/app/models/party-manager/party';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Role } from 'src/app/models/party-manager/role';

@Component({
  selector: 'app-new-party',
  templateUrl: './new-party.component.html',
  styleUrls: ['./new-party.component.scss']
})
export class NewPartyComponent implements OnInit {

  newPartyForm: FormGroup;

  tooltip = {
    submit: '',
    clear: ''
  }


  party: Party;
  roles: Role[]=[];

  characteristics: PartyCharacteristic[]=[];

  partySpecifications:PartySpecification[]

  constructor(
    private formBuilder: FormBuilder,
    private partyService: PartyService,
    private router: Router,
    private notificationsService: NotificationsService
    ) { }

  ngOnInit() {
    this.newPartyForm = this.formBuilder.group({
      code: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
      name:  this.formBuilder.control({ value: '', disabled: false }, Validators.required),
      specRef: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
      roles: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
    });

    this.partyService.getSpec().subscribe(p =>this.partySpecifications = p);
    
    this.partyService.getRoles().subscribe(roles => this.roles=roles);

    this.newPartyForm.get('specRef').valueChanges.subscribe((selectedValue:PartySpecification) => {
      this.partyService.getCharacteristicBySpec(selectedValue.namingId).subscribe((characteristics:PartyCharacteristic[] )=>{
        this.removeCharacteristicsForm();
        this.characteristics = characteristics;
        for(let characteristic of this.characteristics){
          this.newPartyForm.addControl(characteristic.partyCharRef.namingId,this.formBuilder.control(""))
        }
      })
    })
  }

  public clearForm() {
    this.removeCharacteristicsForm();
    this.newPartyForm.reset();
  }

  public removeCharacteristicsForm(){
    for(let characteristic of this.characteristics){
      this.newPartyForm.removeControl(characteristic.partyCharRef.namingId);
    }
    this.characteristics=[]
  }

  goToSearchParty():void{
    this.router.navigate(["/provision/management/party"]);
  }

  public submitForm(){
    let characteristicsForm:PartyCharacteristic[]=[];
    for(let characteristic of this.characteristics){
      if(this.newPartyForm.get(characteristic.partyCharRef.namingId).value){
        characteristicsForm.push({
          partyCharRef:{
            name:characteristic.partyCharRef.name, 
            namingId: characteristic.partyCharRef.namingId
          },
          value:this.newPartyForm.get(characteristic.partyCharRef.namingId).value,
          hjid:characteristic.hjid
        });
      }
    }
    let roles : Role[]=[];
    for(let role of this.rolesControl.value as Role[]){
      roles.push({ 
        id: role.id,
        name: role.name,
        description: role.description
      });
    }
    
    let partySpec = this.specRefControl.value as PartySpecification;
    let party :Party={
       domain: 'ADAMO', 
       name : this.nameControl.value,
        namingId: this.codeControl.value,
        describedByList: characteristicsForm,
        partySpecRef: {
          name: partySpec.name,
          namingId: partySpec.namingId,
          version: partySpec.version 
      },
      allowedRoles: roles
    }
    this.partyService.create(party).subscribe( () => {
      this.notificationsService.showNotification(`El Operador ${this.nameControl.value} se ha creado correctamente`, NotificationLevel.SUCCESS);
      this.goToSearchParty();
    },
    (error) => {
      this.notificationsService.showNotification(
        `Ha habido un problema al crear el Operador:\n${error.error}`, NotificationLevel.ERROR);
        this.goToSearchParty();
    });

  }


  get codeControl(): FormControl {
    return this.newPartyForm.get('code') as FormControl;
  }

  get nameControl(): FormControl {
    return this.newPartyForm.get('name') as FormControl;
  }
  get specRefControl(): FormControl {
    return this.newPartyForm.get('specRef') as FormControl;
  }


  get rolesControl(): FormControl {
    return this.newPartyForm.get('roles') as FormControl;
  }

}
